export function SET_FARM_TO_UPDATE(state, farm) {
  state.farmSelected = farm;
}
